import React from 'react';
import { Link } from 'react-router-dom';
import { testimonials } from '../data/testimonials';

const formatAuthor = (author: string, age?: number) =>
  age ? `${author}, aged ${age}` : author;

const Testimonials: React.FC = () => {
  // Show a selection of testimonials on the homepage
  const featured = testimonials.filter((_, i) => [0, 3, 5, 7].includes(i));

  return (
    <section className="testimonials-home">
      <div className="container">
        <h2 className="testimonials-home-title">What Our Clients Say</h2>
        <div className="testimonials-home-grid">
          {featured.map((testimonial, index) => (
            <blockquote key={index} className="testimonial-card">
              <p>"{testimonial.quote}"</p>
              <cite>— {formatAuthor(testimonial.author, testimonial.age)}</cite>
            </blockquote>
          ))}
        </div>
        <Link to="/testimonials" className="testimonials-home-link">Read more testimonials</Link>
      </div>
    </section>
  );
};

export default Testimonials;
